import { Pointer } from '@yleisradio/areena-types';
import { idFromPointer } from '../utils/pointer';

export const impressionDataAttributeKeys = {
  listSource: 'data-impression-list-source',
  yleId: 'data-impression-yleid',
  analyticsContextComscore: 'data-analytics-context-comscore',
} as const;

type Params = {
  listApiIndex: number;
  cardIndex: number;
  pointer: Pointer | undefined;
  analyticsContextComscore: Record<string, string> | undefined;
};

type ImpressionDataAttributes = Record<
  (typeof impressionDataAttributeKeys)[keyof typeof impressionDataAttributeKeys],
  string | undefined
>;

export const getDataAttributesImpression = ({
  listApiIndex,
  cardIndex,
  pointer,
  analyticsContextComscore,
}: Params): ImpressionDataAttributes => {
  return {
    [impressionDataAttributeKeys.listSource]: `${listApiIndex}:${cardIndex}`,
    [impressionDataAttributeKeys.yleId]: pointer
      ? idFromPointer(pointer)
      : undefined,
    [impressionDataAttributeKeys.analyticsContextComscore]:
      analyticsContextComscore
        ? JSON.stringify(analyticsContextComscore)
        : undefined,
  };
};
